import { Component } from '@angular/core';
import { VexLayoutService } from '@vex/services/vex-layout.service';
import { Observable } from 'rxjs';
import { RouterOutlet } from '@angular/router';
import { AsyncPipe, NgIf } from '@angular/common';



import { BaseLayoutComponent } from '../base-layout/base-layout.component';
import { VexConfig } from '@vex/config/vex-config.interface';
import { VexConfigService } from '@vex/config/vex-config.service';
import { VexProgressBarComponent } from "../../../../@vex/components/vex-progress-bar/vex-progress-bar.component";

@Component({
  selector: 'vex-guest-layout',
  templateUrl: './guest-layout.component.html',
  styleUrls: ['./guest-layout.component.scss'],
  imports: [
    BaseLayoutComponent,
    NgIf,
    AsyncPipe,
    RouterOutlet,
    VexProgressBarComponent
],
  standalone: true
})
export class GuestLayoutComponent {
  config$: Observable<VexConfig> = this.configService.config$;

  constructor(
    private readonly layoutService: VexLayoutService,
    private readonly configService: VexConfigService
  ) {}
}
